var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 22.6667H28C28.7364 22.6667 29.3333 23.2636 29.3333 24C29.3333 24.6837 28.8187 25.2473 28.1555 25.3244L28 25.3333H3.99999C3.26362 25.3333 2.66666 24.7364 2.66666 24C2.66666 23.3163 3.18138 22.7527 3.8445 22.6756L3.99999 22.6667ZM3.99983 14.6667L27.9999 14.6637C28.7363 14.6637 29.3333 15.2605 29.3333 15.9969C29.3333 16.6807 28.8188 17.2444 28.1556 17.3215L28.0001 17.3304L4.00015 17.3333C3.26378 17.3335 2.66666 16.7365 2.66666 16.0001C2.66666 15.3164 3.18124 14.7528 3.84434 14.6756L3.99983 14.6667ZM3.99999 6.66666H28C28.7364 6.66666 29.3333 7.26362 29.3333 8C29.3333 8.68378 28.8187 9.24734 28.1555 9.32436L28 9.33333H3.99999C3.26362 9.33333 2.66666 8.73637 2.66666 8C2.66666 7.31621 3.18138 6.75265 3.8445 6.67564L3.99999 6.66666Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.0e8a9df57eb849d2feac348659e63c3c.svg";
export { ForwardRef as ReactComponent };